/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliLoginDto } from '../../models/amoxcalli-login-dto';
import { AmoxcalliLoginResponseDtoApiResponse } from '../../models/amoxcalli-login-response-dto-api-response';

export interface ApiAuthLoginPost$Json$Params {
      body?: AmoxcalliLoginDto
}

export function apiAuthLoginPost$Json(http: HttpClient, rootUrl: string, params?: ApiAuthLoginPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliLoginResponseDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAuthLoginPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliLoginResponseDtoApiResponse>;
    })
  );
}

apiAuthLoginPost$Json.PATH = '/api/auth/login';
